// @ts-nocheck
import { ethers } from 'ethers'

export const approve = async (lpContract, masterChefContract, account) => {
  return lpContract.approve(masterChefContract.address, ethers.constants.MaxUint256)
}
